export const DEFAULT_LOCALE = 'en-GB'; // eslint-disable-line
